import {NavigateFunction} from "react-router-dom";
import {getUserTokenOrRedirect} from "../../shared/services/auth.service";
import {EstimateCrewMemberDto, UpdateEstimateCrewMembersDto} from "../../shared/dtos/estimate-crew-member.dto";

export async function getEstimateCrewMembers(navigate: NavigateFunction, estimateId: number): Promise<EstimateCrewMemberDto[]> {
  const token = await getUserTokenOrRedirect(navigate)
  return await fetch(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/estimates/${estimateId}/crew-members`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then(async r => r.ok ? (await r.json()) as EstimateCrewMemberDto[] : Promise.reject(r));
}

/**
 * Replace-all membership write; the server syncs estimate.crewSize to
 * max(1, member count) and returns the refreshed membership list.
 */
export async function setEstimateCrewMembers(navigate: NavigateFunction, estimateId: number, update: UpdateEstimateCrewMembersDto): Promise<EstimateCrewMemberDto[]> {
  const token = await getUserTokenOrRedirect(navigate)
  return await fetch(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/estimates/${estimateId}/crew-members`,
    {
      method: 'PUT',
      body: JSON.stringify(update),
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }).then(async r => r.ok ? (await r.json()) as EstimateCrewMemberDto[] : Promise.reject(r));
}
